import React, { useEffect, useState, useRef } from "react";
import { ProductCard } from "./product-card";
const MenuProductList = ({ menuCategories, categories }) => {
  const [isScrolling, setIsScrolling] = useState(false);
  const categoryRefs = useRef({});

  const categorizedProducts = categories?.map((category) => {
    const matched = menuCategories?.find(
      (product) => product?.name === category
    );
    return {
      category,
      products: matched?.products || [],
    };
  });

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolling(true);
      } else {
        setIsScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToCategory = (category) => {
    const categoryRef = categoryRefs.current[category];
    if (categoryRef) {
      categoryRef.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="container-product">
      {categorizedProducts?.length > 0 ? (
        categorizedProducts?.map(({ category, products }) => (
          <div
            key={category}
            ref={(el) => (categoryRefs.current[category] = el)}
          >
            <h2
              className="category"
              onClick={() => scrollToCategory(category)}
              style={{ cursor: "pointer" }}
            >
              {category}
            </h2>
            <div>
              {products?.map((product, index) => {
                const isLast = index === products.length - 1;
                return (
                  <ProductCard
                    product={product}
                    key={product.id}
                    isLast={isLast} 
                  />
                );
              })}
            </div>
          </div>
        ))
      ) : (
        <div className="no-data">لا توجد منتجات في القائمة</div>
      )}
    </div>
  );
};

export default MenuProductList;
